import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSecs = prev.seconds - 1;
        let newMins = prev.minutes;
        let newHours = prev.hours;
        if (newSecs < 0) {
          newSecs = 59;
          newMins -= 1;
        }
        if (newMins < 0) {
          newMins = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMins,
          seconds: newSecs
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex flex-col items-center justify-center space-y-2 my-6" data-id="element-57">
      <div className="text-brand-red font-bold text-sm tracking-widest uppercase" data-id="element-58">
        Oferta por tiempo limitado
      </div>
      <div className="flex space-x-4" data-id="element-59">
        <div className="flex flex-col items-center" data-id="element-60">
          <div className="bg-brand-panel border border-brand-border rounded-lg w-16 h-16 flex items-center justify-center text-2xl font-serif font-bold text-brand-gold shadow-lg" data-id="element-61">
            {format(timeLeft.hours)}
          </div>
          <span className="text-xs text-gray-400 mt-1 uppercase tracking-wider" data-id="element-62">
            Horas
          </span>
        </div>
        <div className="text-2xl font-serif font-bold text-brand-gold mt-4" data-id="element-63">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-64">
          <div className="bg-brand-panel border border-brand-border rounded-lg w-16 h-16 flex items-center justify-center text-2xl font-serif font-bold text-brand-gold shadow-lg" data-id="element-65">
            {format(timeLeft.minutes)}
          </div>
          <span className="text-xs text-gray-400 mt-1 uppercase tracking-wider" data-id="element-66">
            Min
          </span>
        </div>
        <div className="text-2xl font-serif font-bold text-brand-gold mt-4" data-id="element-67">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-68">
          <div className="bg-brand-panel border border-brand-border rounded-lg w-16 h-16 flex items-center justify-center text-2xl font-serif font-bold text-brand-gold shadow-lg" data-id="element-69">
            {format(timeLeft.seconds)}
          </div>
          <span className="text-xs text-gray-400 mt-1 uppercase tracking-wider" data-id="element-70">
            Seg
          </span>
        </div>
      </div>
    </div>;
}